export default __webpack_public_path__ + "static/media/t5.194039d8.jpeg";